import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon4: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M4.005 2.874a.5.5 0 0 1 1 0v5.574a.5.5 0 0 1-.906.292L1 4.426v4.022a.5.5 0 0 1-1 0V2.874a.5.5 0 0 1 .906-.292l3.099 4.313V2.874ZM12.62 1.47a4.48 4.48 0 0 1 2.383 3.957c0 2.477-2.016 4.484-4.501 4.484-2.485 0-4.501-2.007-4.501-4.484a4.48 4.48 0 0 1 2.384-3.958.5.5 0 0 1 .47.883 3.481 3.481 0 0 0-1.854 3.075 3.492 3.492 0 0 0 3.501 3.484 3.492 3.492 0 0 0 3.501-3.484 3.48 3.48 0 0 0-1.853-3.074.501.501 0 0 1 .47-.883ZM10.502 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Zm7.3 8.619c-.177.488-.889.416-.965-.098l-.821-5.574a.5.5 0 1 1 .989-.146l.533 3.615.994-2.739a.5.5 0 0 1 .94 0l.994 2.747.546-3.625a.5.5 0 0 1 .989.149l-.84 5.574c-.077.513-.788.584-.964.096l-1.196-3.303-1.199 3.304Z"
      />
    </Svg>
  )
}
